import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/uiDir/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";

const Docs = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-10">
            <h1 className="text-4xl font-heading font-bold mb-2">Documentation</h1>
            <p className="text-muted-foreground">
              Learn how to set up and share your PortfolioHub profile.
            </p>
          </div>

          <div className="space-y-6">
            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Getting Started</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Create your account, complete your profile, and add your first project.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Sharing Your Portfolio</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Use the share tools in your dashboard to copy links and generate QR codes.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Managing Projects</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Keep your work organized with categories, tags, and featured items.
              </CardContent>
            </Card>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/support">
              <Button variant="outline">Visit Support</Button>
            </Link>
            <Link to="/">
              <Button variant="ghost">Back to Home</Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Docs;
